import {
  AspectRatio,
  Box,
  Flex,
  HStack,
  SimpleGrid,
  Text,
  VStack
} from '@chakra-ui/react'
import Video from '@components/video'
import Image from 'next/image'

import BuyButton from './buy-button'
import Reel from './reels'
import { MainContainer } from '.'

const BelieveItem = ({ src, title }: { src: any; title: string }) => {
  return (
    <VStack gap={0}>
      <AspectRatio
        w={{
          base: '35px',
          sm: '40px',
          md: '40px',
          lg: '60px'
        }}
        ratio={1 / 1}
        position="relative"
        zIndex={10}
      >
        <Image src={src} alt={title} fill />
      </AspectRatio>
      <Text
        fontSize={{
          base: 13,
          lg: 18
        }}
        fontWeight={500}
        lineHeight={1.3}
        textAlign="center"
        w={{
          base: '90px',
          sm: '100px',
          md: '110px',
          lg: '150px'
        }}
        mt={2}
      >
        {title}
      </Text>
    </VStack>
  )
}

const GripTumblerBelieve = () => {
  return (
    <>
      <MainContainer>
        <VStack data-aos="fade-up" pb={10} alignItems="center">
          <VStack
            mt={{ base: 10, lg: 20 }}
            w={{
              base: 600,
              lg: 900
            }}
            alignItems={{
              base: 'center',
              md: 'center'
            }}
            justifyContent="center"
          >
            <Text textStyle="gripMainTitle" fontWeight={500}>
              SEE IT TO BELIEVE IT
            </Text>

            <VStack
              w={{
                base: '60%',
                sm: '60%',
                md: '100%'
              }}
              alignItems={'start'}
              mt={{
                base: 0,
                lg: 10
              }}
            >
              <Video url="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/video-1711618257631.mp4" />
            </VStack>
          </VStack>
        </VStack>
      </MainContainer>
      <Flex
        data-aos="fade-up"
        w={'100%'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Reel />
      </Flex>

      <MainContainer data-aos="fade-up">
        <VStack pb={10} alignItems="center">
          <VStack
            mt={{ base: 10, lg: 20 }}
            w={{
              base: 600,
              lg: 900
            }}
            alignItems={{
              base: 'center',
              md: 'center'
            }}
            justifyContent="center"
          >
            <AspectRatio
              w={{
                base: '280px',
                sm: '300px',
                md: '400px',
                lg: '600px'
              }}
              ratio={1474 / 752}
              position="relative"
              mt={{
                base: 0,
                lg: 10
              }}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/five-tumbler-1711633255192.png"
                alt="five tumbler"
                fill
              />
            </AspectRatio>

            <Text
              mt={5}
              textStyle="gripMainTitle"
              w={{
                base: '380px',
                sm: '380px',
                md: '380px',
                lg: '700px'
              }}
              textAlign={'center'}
            >
              ARCTIC GRIP TUMBLER 480ML
            </Text>

            <VStack
              w="100%"
              alignItems={'center'}
              mt={{
                base: 0,
                lg: 5
              }}
            >
              <BuyButton ml={0} color="#000" borderColor="#000" />
            </VStack>

            <HStack justifyItems="center" mt={5} gap="20px">
              <VStack gap={0}>
                <Text
                  fontSize={{
                    base: 34,
                    lg: 60
                  }}
                  fontWeight={700}
                  lineHeight={1.3}
                  textAlign="center"
                  w={{
                    base: '90px',
                    sm: '100px',
                    md: '120px',
                    lg: '150px'
                  }}
                >
                  304
                </Text>
                <Text
                  fontSize={{
                    base: 13,
                    lg: 18
                  }}
                  fontWeight={500}
                  lineHeight={1.3}
                  textAlign="center"
                  w={{
                    base: '90px',
                    sm: '100px',
                    md: '120px',
                    lg: '150px'
                  }}
                  mt={2}
                >
                  Stainless Steel
                </Text>
              </VStack>
              <VStack gap={0}>
                <AspectRatio
                  w={{
                    base: '35px',
                    sm: '40px',
                    md: '40px',
                    lg: '60px'
                  }}
                  ratio={1 / 1}
                  position="relative"
                  zIndex={10}
                >
                  <Image
                    src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-grip-base-1711633630583.png"
                    alt="icon grip base"
                    fill
                  />
                </AspectRatio>
                <Text
                  fontSize={{
                    base: 13,
                    lg: 18
                  }}
                  fontWeight={500}
                  lineHeight={1.3}
                  textAlign="center"
                  w={{
                    base: '90px',
                    sm: '100px',
                    md: '120px',
                    lg: '150px'
                  }}
                  mt={2}
                >
                  Non-slip suction grip base
                </Text>
              </VStack>
            </HStack>

            <SimpleGrid
              columns={{ base: 3, sm: 3 }}
              gap={6}
              w={{
                base: '50%',
                sm: '80%',
                md: '70%'
              }}
              mt={5}
            >
              <BelieveItem
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-droplet-1711633174578.png"
                title="Leak-proof Lid"
              />
              <BelieveItem
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-technology-1711633091559.png"
                title="Sweat Free Technology"
              />
              <BelieveItem
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-cup-1711633630582.png"
                title="Car Cup Holder Friendly"
              />
              <BelieveItem
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/keep-cool-1711633012268.png"
                title="Keep cold for up to 24 hours"
              />
              <BelieveItem
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/keep-warm-1711633012268.png"
                title="Keep warm for up to 12 hours"
              />
              <BelieveItem
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-bpa-1711633174578.png"
                title="BPA Free"
              />
            </SimpleGrid>
          </VStack>
        </VStack>
      </MainContainer>
    </>
  )
}

export default GripTumblerBelieve
